// Use IntersectionObserver instead of ScrollTrigger — works in any scroll container (Horizon, etc.)
(function () {
  if (typeof gsap === 'undefined') return;
  if (typeof ScrollTrigger !== 'undefined') gsap.registerPlugin(ScrollTrigger);

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onVisible(selector, callback, threshold) {
    var els = typeof selector === 'string' ? document.querySelectorAll(selector) : [selector];
    if (!els.length) return;
    var observed = new Set();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !observed.has(entry.target)) {
          observed.add(entry.target);
          observer.unobserve(entry.target);
          callback(entry.target);
        }
      });
    }, { threshold: threshold || 0.05, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { observer.observe(el); });
  }

  function init() {
    initHero();
    if (!reduced) {
      initStage();
      initCauses();
      initShowcase();
      initTimeline();
      initBeforeAfter();
      initStats();
      initExperts();
      initMidCta();
      initFadeUps();
    } else {
      // Reduced motion: make everything visible immediately
      document.querySelectorAll('.gsap-fade-up,.gsap-fade-left,.gsap-fade-right,.fz-stage__image,.fz-stage__content,.fz-causes__card,.fz-showcase__card,.fz-experts__card,.fz-stats__left,.fz-stats__right,.fz-midcta__inner').forEach(function(el){
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
    }
  }

  /* ── Hero (no scroll trigger — fires on load) ── */
  function initHero() {
    var hero = document.querySelector('.fz-hero');
    if (!hero) return;

    hero.querySelectorAll('.fz-hero__line').forEach(function (line) {
      var text = line.textContent.trim();
      line.innerHTML = text.split(' ').map(function (w) {
        return '<span class="hw" style="display:inline-block;overflow:hidden"><span style="display:inline-block">' + w + '</span></span>';
      }).join(' ');
    });

    if (!reduced) {
      gsap.from('.fz-hero__line .hw > span', { y: '110%', opacity: 0, duration: 0.7, ease: 'power3.out', stagger: 0.06, delay: 0.2 });
      gsap.from('.fz-hero__badge', { opacity: 0, y: 16, duration: 0.5, delay: 0.1 });
      gsap.from('.fz-hero__sub',   { opacity: 0, y: 20, duration: 0.5, delay: 0.7 });
      gsap.from('.fz-hero__ctas',  { opacity: 0, y: 20, duration: 0.5, delay: 0.9 });
    }
  }

  /* ── Product Stage ── */
  function initStage() {
    var stage = document.querySelector('.fz-stage');
    if (!stage) return;
    var img = stage.querySelector('.fz-stage__image');
    var content = stage.querySelector('.fz-stage__content');
    if (img) gsap.set(img, { x: -50, opacity: 0 });
    if (content) gsap.set(content, { x: 50, opacity: 0 });
    onVisible('.fz-stage', function () {
      if (img) gsap.to(img, { x: 0, opacity: 1, duration: 0.9, ease: 'power3.out' });
      if (content) gsap.to(content, { x: 0, opacity: 1, duration: 0.9, ease: 'power3.out', delay: 0.1 });
    });
  }

  /* ── Root Causes ── */
  function initCauses() {
    var cards = document.querySelectorAll('.gsap-cause-card');
    if (!cards.length) return;
    gsap.set(cards, { opacity: 0, y: 40 });
    onVisible('.fz-causes__grid', function () {
      gsap.to(cards, { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out', stagger: 0.1 });
    });
  }

  /* ── Product Showcase ── */
  function initShowcase() {
    var card = document.querySelector('.fz-showcase__card');
    if (!card) return;
    gsap.set(card, { opacity: 0, scale: 0.96 });
    onVisible('.fz-showcase__card', function () {
      gsap.to(card, { opacity: 1, scale: 1, duration: 0.7, ease: 'power2.out' });
    });
  }

  /* ── Timeline ── */
  function initTimeline() {
    var fill = document.querySelector('.fz-timeline__line-fill');
    var milestones = document.querySelectorAll('.fz-timeline__milestone');
    if (!fill) return;
    onVisible('.fz-timeline', function () {
      gsap.to(fill, { strokeDashoffset: 0, duration: 1.4, ease: 'power2.inOut' });
      milestones.forEach(function (m, i) {
        setTimeout(function () { m.classList.add('is-active'); }, i * 400 + 300);
      });
    });
  }

  /* ── Before/After ── */
  function initBeforeAfter() {
    var afterWrap = document.querySelector('.fz-ba__img-wrap--after');
    if (!afterWrap) return;
    gsap.set(afterWrap, { clipPath: 'inset(0 100% 0 0)' });
    onVisible('.fz-ba', function () {
      gsap.to(afterWrap, { clipPath: 'inset(0 0% 0 0)', duration: 1.2, ease: 'power3.inOut' });
      gsap.fromTo('.fz-ba__tag',
        { scale: 0, opacity: 0 },
        { scale: 1, opacity: 1, duration: 0.4, ease: 'back.out(1.5)', stagger: 0.08, delay: 0.8 }
      );
    });
  }

  /* ── Stats counter ── */
  function initStats() {
    var left = document.querySelector('.fz-stats__left');
    var right = document.querySelector('.fz-stats__right');
    if (left) gsap.set(left, { x: -40, opacity: 0 });
    if (right) gsap.set(right, { x: 40, opacity: 0 });

    onVisible('.fz-stats', function () {
      if (left) gsap.to(left, { x: 0, opacity: 1, duration: 0.8, ease: 'power2.out' });
      if (right) gsap.to(right, { x: 0, opacity: 1, duration: 0.8, ease: 'power2.out' });

      document.querySelectorAll('.fz-stats__num').forEach(function (el) {
        var target = parseFloat(el.dataset.target) || 0;
        gsap.to({ val: 0 }, {
          val: target, duration: 1.6, ease: 'power2.out',
          onUpdate: function () { el.textContent = Math.round(this.targets()[0].val); }
        });
      });

      document.querySelectorAll('.fz-stats__sep').forEach(function (sep, i) {
        setTimeout(function () { sep.classList.add('is-visible'); }, i * 200 + 400);
      });
    });
  }

  /* ── Expert cards ── */
  function initExperts() {
    var cards = document.querySelectorAll('.fz-experts__card');
    if (!cards.length) return;
    gsap.set(cards, { opacity: 0, y: 50 });
    onVisible('.fz-experts__grid', function () {
      gsap.to(cards, { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out', stagger: 0.15 });
    });
  }

  /* ── Mid CTA ── */
  function initMidCta() {
    var inner = document.querySelector('.fz-midcta__inner');
    if (!inner) return;
    gsap.set(inner, { opacity: 0, y: 40 });
    onVisible('.fz-midcta__inner', function () {
      gsap.to(inner, { opacity: 1, y: 0, duration: 0.7, ease: 'power2.out' });
    });
  }

  /* ── Generic .gsap-fade-up elements ── */
  function initFadeUps() {
    document.querySelectorAll('.gsap-fade-up').forEach(function (el) {
      gsap.set(el, { opacity: 0, y: 40 });
      onVisible(el, function () {
        gsap.to(el, { opacity: 1, y: 0, duration: 0.7, ease: 'power2.out' });
      });
    });
  }

  // Run: defer scripts execute after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
